import "core-js/modules/es6.array.reduce";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import localForage from 'localforage';
import PubSub from 'pubsub-js';
var store = localForage.createInstance({
  name: 'productsList'
});
export var NOTIFY_CHANGES = 'NOTIFY_CHANGES';

var notifyChanges = function notifyChanges() {
  PubSub.publish(NOTIFY_CHANGES);
};

export var get = function get(productId) {
  return store.getItem(productId);
};
export var list = function list() {
  var productList = [];
  return store.iterate(function (value) {
    productList.push(value);
  }).then(function () {
    return productList;
  });
};
export var add = function add(product, quantity) {
  if (quantity === void 0) {
    quantity = 1;
  }

  return get(product.id).then(function (currentProductData) {
    return store.setItem(product.id, _objectSpread({}, product, {
      __quantity: (currentProductData && currentProductData.__quantity || 0) + quantity
    }));
  }).then(notifyChanges);
};
export var remove = function remove(product, quantity) {
  if (quantity === void 0) {
    quantity = null;
  }

  if (!quantity) {
    return store.removeItem(product.id).then(notifyChanges);
  }

  return get(product.id).then(function (currentProductData) {
    var targetQuantity = currentProductData.__quantity - quantity;

    if (targetQuantity < 1) {
      return store.removeItem(product.id).then(notifyChanges);
    }

    return store.setItem(product.id, _objectSpread({}, product, {
      __quantity: targetQuantity
    })).then(notifyChanges);
  });
};
export var set = function set(product, quantity) {
  if (quantity <= 0) {
    return store.removeItem(product.id).then(notifyChanges);
  }

  return store.setItem(product.id, _objectSpread({}, product, {
    __quantity: quantity
  })).then(notifyChanges);
};
export var getQuantity = function getQuantity() {
  return list().then(function (productsList) {
    return productsList.reduce(function (accumulator, product) {
      return accumulator + product.__quantity;
    }, 0);
  });
};
export var clear = function clear() {
  return store.clear().then(notifyChanges);
};